module.exports = __webpack_public_path__ + "img/2.a39ca02b.png";